// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__Y5qIW","list":"PatternAutocomplete_list__37l7h"};